// src/context/AuthContext.tsx
import React, { useState, useEffect, createContext, useContext, ReactNode } from 'react';
import { jwtDecode } from 'jwt-decode';

// Definiujemy, jakie dane przechowuje nasz token
interface DecodedToken {
    nameid: string; // ID u�ytkownika
    unique_name: string; // Nazwa u�ytkownika (email)
    exp: number; // Data wyga�ni�cia
}

// Definiujemy, co nasz kontekst udost�pnia ca�ej aplikacji
interface AuthContextType {
    isAuthenticated: boolean;
    user: DecodedToken | null;
    login: (token: string) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
    const [user, setUser] = useState<DecodedToken | null>(null);

    useEffect(() => {
        if (token) {
            try {
                const decodedToken: DecodedToken = jwtDecode(token);
                // Sprawdzamy, czy token nie wygas�
                if (Date.now() >= decodedToken.exp * 1000) {
                    logout(); // Je�li tak, wylogowujemy
                } else {
                    setUser(decodedToken);
                }
            } catch (error) {
                console.error("B��d dekodowania tokenu, wylogowywanie.", error);
                logout(); // Je�li token jest uszkodzony, wylogowujemy
            }
        } else {
            setUser(null);
        }
    }, [token]);

    const login = (newToken: string) => {
        localStorage.setItem('token', newToken);
        setToken(newToken);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
    };

    const isAuthenticated = !!token;

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Nasz niestandardowy hook, kt�ry zg�asza b��d, je�li jest u�ywany w z�ym miejscu
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth musi by� u�ywane wewn�trz AuthProvider');
    }
    return context;
};
